module.exports = __webpack_public_path__ + "img/13.56424f27.jpg";